export default {
  label: 'I authorize [PARTNER_NAME] and its representatives to contact me via SMS. I am providing my consent by leaving the opt-in checked. Message and data rates may apply. [TERMS_LINK].',
  termsText: 'Terms',
  termsLink: 'https://policies.edusites.net/terms'
}